/**
 * Created by rickborst on 01/08/2017.
 */

import Device from 'models/device';
import {getInstance as getStorageManager} from 'storage/manager';

/**
 * Generates random string of specific length.
 *
 * @param {number} length - Required length or random string.
 * @returns {string} - Random, string.
 */
function generateRandomString (length) {

        let outStr = '',
            newStr,
            bits = 36;

        while (outStr.length < length) {
            newStr = Math.random().toString(bits).slice(2);
            outStr += newStr.slice(0, Math.min(newStr.length, (length - outStr.length)));
        }
        return outStr.toUpperCase();
}

/**
 * Creates and returns a fingerprint for the browser.
 *
 * @returns {Promise} Fingerprint promise.
 */
function getFingerprint () {

    let storeManager = getStorageManager(),
        deviceID = storeManager.read('uniqueDeviceID');

    if (deviceID) {
        return Promise.resolve(deviceID);
    }

    deviceID = new Date().getTime() + generateRandomString(20);
    storeManager.store('uniqueDeviceID', deviceID);

    return Promise.resolve(deviceID);
}

/**
 * Creates and return device object based on the current device.
 *
 * @returns {Object} Device object.
 */
function getDevice () {

    return getFingerprint()
        .then(udid => {
            let {
                    platform,
                    userAgent
                } = navigator,
                name = `${platform} - ${userAgent}`,
                activationDate = Date.now();

            return new Device({
                udid,
                name,
                activationDate
            });
        });
}

export {
    getDevice
};


// WEBPACK FOOTER //
// ./src/js/utils/device/device.js